<ix-modal-header [title]="title" [loading]="isFormLoading"></ix-modal-header>

<mat-card>
  <mat-card-content>
    <form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
      <ix-fieldset>
        <ix-input
          formControlName="name"
          [label]="nameLabel | translate"
          [readonly]="true"
        ></ix-input>

        <ix-input
          formControlName="data_quota"
          [label]="dataQuotaLabel | translate"
          [tooltip]="dataQuotaTooltip | translate"
          [format]="formatter.memorySizeFormatting"
          [parse]="formatter.memorySizeParsing"
        ></ix-input>

        <ix-input
          formControlName="obj_quota"
          type="number"
          [label]="objectQuotaLabel | translate"
          [tooltip]="objectQuotaTooltip | translate"
        ></ix-input>
      </ix-fieldset>

      <ix-form-actions>
        <button
          type="submit"
          mat-button
          color="primary"
          ixTest="save"
          [disabled]="form.invalid || isFormLoading"
        >
          {{ 'Save' | translate }}
        </button>
      </ix-form-actions>
    </form>
  </mat-card-content>
</mat-card>
